import { type TaxMode } from '@webapp/modules/expense/business-logic/use-cases/ComputeExpenseLineItemTotals'
import {
  type ExpenseTaxSelectValue,
  isCustomTax,
} from '../types/ExpenseTaxSelectValue'

export const toTaxMode = (
  value: Nullable<ExpenseTaxSelectValue>,
  taxAmount: number
): TaxMode => {
  if (isCustomTax(value))
    return { mode: 'custom', percentage: value.percentage }
  return value?.id === '$'
    ? { mode: 'dollar', amount: taxAmount }
    : { mode: 'percent', amount: taxAmount }
}
